import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Compass } from "lucide-react";
import { http } from "@/lib/api";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export const CheckInPrompt = () => {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    http.get("/assessment/me").then((r) => { setD(r.data); if (r.data.needed && !sessionStorage.getItem("cl_checkin_later")) setOpen(true); }).catch(() => {});
  }, []);
  if (!d?.needed) return null;
  const later = () => { sessionStorage.setItem("cl_checkin_later", "1"); setOpen(false); };
  const started = !!d.assessment && d.assessment.term === d.term && d.assessment.status !== "done";
  return (
    <>
      <Link to="/check-in" data-testid="checkin-banner" className="mt-8 flex items-center gap-4 rounded-3xl bg-[#2C4A3E] text-[#F7F3EB] px-6 py-5 hover:bg-[#1E352B] transition-colors">
        <Compass className="w-8 h-8 text-[#F2D49B] shrink-0" />
        <span className="flex-1"><b className="font-display text-xl block">{(() => { const t = `${{ winter: "mid-year", spring: "end-of-year" }[d.term] || "start-of-year"} check-in`; return started ? `Finish your ${t}` : t[0].toUpperCase() + t.slice(1); })()}</b><span className="text-sm opacity-80">{d.term !== "fall" ? "See how much you've grown since the fall. About 8 minutes." : "Help your Buddy learn how you learn best. About 15 minutes."}</span></span>
        <span className="px-5 py-2 rounded-full bg-[#F2D49B] text-[#5B3A1E] text-sm font-medium">{started ? "Continue" : "Start"}</span>
      </Link>
      <Dialog open={open} onOpenChange={(o) => (o ? setOpen(true) : later())}>
        <DialogContent className="bg-[#FDFBF7] max-w-md" data-testid="checkin-modal">
          <Compass className="w-10 h-10 text-[#C87D53]" />
          <DialogTitle className="font-display text-3xl text-[#2C4A3E]">{d.term === "spring" ? "You did it. Time to see a whole year of growth!" : d.term === "winter" ? "Halfway there. Look how you've grown!" : "New school year, new you!"}</DialogTitle>
          <p className="text-stone-600">{d.term !== "fall" ? "Take a quick skill check to see your growth since the fall. It's short, and you can't get it wrong." : "Take a quick check-in so your lessons fit how you learn. It's fun, and you can't get it wrong."}</p>
          <div className="flex gap-3 mt-2">
            <Link to="/check-in" onClick={() => setOpen(false)} data-testid="checkin-modal-start" className="px-6 py-3 rounded-full bg-[#C87D53] text-white">{started ? "Continue" : "Start now"}</Link>
            <button onClick={later} data-testid="checkin-modal-later" className="px-5 py-3 rounded-full border border-[#E6DEC3] text-stone-600">Later</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
